var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9688 0.5625H4.46875C2.39768 0.5625 0.71875 2.24143 0.71875 4.3125V20.8125C0.71875 22.8836 2.39768 24.5625 4.46875 24.5625H20.9688C23.0398 24.5625 24.7188 22.8836 24.7188 20.8125V4.3125C24.7188 2.24143 23.0398 0.5625 20.9688 0.5625Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41875 18.5625H6.86875V10.5375H9.41875V18.5625ZM8.14375 9.4125C7.31875 9.4125 6.71875 8.8125 6.71875 7.9875C6.71875 7.1625 7.39375 6.5625 8.14375 6.5625C8.96875 6.5625 9.56875 7.1625 9.56875 7.9875C9.56875 8.8125 8.96875 9.4125 8.14375 9.4125ZM18.7188 18.5625H16.1688V14.2125C16.1688 12.9375 15.6437 12.5625 14.8937 12.5625C14.1437 12.5625 13.3937 13.1625 13.3937 14.2875V18.5625H10.8438V10.5375H13.2437V11.6625C13.4687 11.1375 14.3687 10.3125 15.6437 10.3125C17.0687 10.3125 18.5688 11.1375 18.5688 13.6125V18.5625H18.7188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.307220b43dcc251a020365506b4af0fc.svg";
export { ForwardRef as ReactComponent };